import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import printlogo from '../../printpropertise/printlogoceylonika.png';

const pdfStyles = StyleSheet.create({
    page: {
        paddingTop: 35,
        paddingBottom: 65,
        paddingHorizontal: 35,
        fontSize: 9,
        fontFamily: 'Helvetica',
    },
    headerSection: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 20,
        borderBottomWidth: 1,
        borderBottomColor: '#cccccc',
        paddingBottom: 10,
    },
    companyDetails: {
        flexDirection: 'column',
    },
    logo: { 
        width: 150,
        height: 45,
        marginBottom: 5,
    },
    companyName: {
        fontSize: 11,
        fontFamily: 'Helvetica-Bold',
    },
    companyAddress: {
        fontSize: 9,
        maxWidth: 250,
    },
    reportInfo: {
        textAlign: 'right',
    },
    reportTitle: {
        fontSize: 14,
        fontFamily: 'Helvetica-Bold',
        marginBottom: 5,
    },
    reportDate: {
        fontSize: 9,
        marginBottom: 2,
    },
    reportTime: {
        fontSize: 9,
        marginBottom: 2,
        color: '#000',
    },
    filterInfo: {
        fontSize: 8,
        fontFamily: 'Helvetica-Oblique',
    },
    table: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderColor: '#bfbfbf',
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
        marginBottom: 20,
    },
    tableRow: {
        flexDirection: "row",
    },
    tableColHeader: {
        borderStyle: "solid",
        borderColor: '#bfbfbf',
        borderBottomColor: '#000',
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        backgroundColor: '#e0e0e0',
        padding: 5,
        textAlign: 'center',
        fontFamily: 'Helvetica-Bold',
    },
    tableCol: {
        borderStyle: "solid",
        borderColor: '#bfbfbf',
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        justifyContent: 'center',
    },
    tableCellHeader: {
        margin: "auto",
        fontSize: 9,
        fontFamily: 'Helvetica-Bold',
    },
    tableCell: {
        fontSize: 8,
        paddingHorizontal: 2,
        paddingVertical: 2,
        overflow: 'hidden',
        textAlign: 'left',
    },
    tableCellRight: {
        fontSize: 8,
        paddingHorizontal: 2,
        paddingVertical: 2,
        overflow: 'hidden',
        textAlign: 'right',
        width: '100%',
    },
    colProductCode: { width: '15%' },
    colName: { width: '30%' },
    colSize: { width: '10%' },
    colUOM: { width: '10%' },
    colQty: { width: '15%' },
    colValue: { width: '20%' },

    summaryRow: {
        flexDirection: 'row',
        backgroundColor: '#f0f0f0',
    },
    summaryCellLabel: {
        width: '65%',
        padding: 5,
        textAlign: 'right',
        fontSize: 9,
        borderStyle: "solid",
        borderColor: '#bfbfbf',
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 1,
    },
    summaryCellQty: {
        width: '15%',
        padding: 5,
        textAlign: 'right',
        fontSize: 9,
        borderStyle: "solid",
        borderColor: '#bfbfbf',
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 1,
    },
    summaryCellValue: {
        width: '20%',
        padding: 5,
        textAlign: 'right',
        fontSize: 9,
        borderStyle: "solid",
        borderColor: '#bfbfbf',
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 1,
    },
    footer: {
        position: 'absolute',
        bottom: 30,
        left: 35,
        right: 35,
        textAlign: 'center',
        color: 'grey',
        fontSize: 8,
    },
});

export const StockReportDocument = ({ data, allStocksFlag, selectedStockName }) => {
    const totalQty = data.reduce((sum, item) => sum + (Number(item.availableQty) || 0), 0);
    const totalValue = data.reduce((sum, item) => sum + (parseFloat(item.itemTotalCostValue) || 0), 0);

    return (
        <Document>
            <Page size="A4" style={pdfStyles.page} orientation="portrait">
                {/* Header */}
                <View style={pdfStyles.headerSection} fixed>
                    <View style={pdfStyles.companyDetails}>
                        <Image src={printlogo} style={pdfStyles.logo} /> {/* Using printlogo as per existing import */}
                        <Text style={pdfStyles.companyName}>Ceylonika Cosmetics (Pvt) Ltd</Text>
                        <Text style={pdfStyles.companyAddress}>154/11, Pushparama Road, Kadawatha</Text>
                        <Text style={pdfStyles.companyAddress}>www.ceylonikacosmetics.com | info@ceylonikacosmetics.com</Text>
                        <Text style={pdfStyles.companyAddress}>+94 112 92 44 20</Text>
                    </View>
                    <View style={pdfStyles.reportInfo}>
                        <Text style={pdfStyles.reportTitle}>Current Live Stock Report</Text>
                        <Text style={pdfStyles.reportDate}>Stock Name : {selectedStockName ? selectedStockName : ''}</Text>
                        <Text style={pdfStyles.reportTime}>Print Date/Time: {new Date().toLocaleDateString()} {new Date().toLocaleTimeString()}</Text>
                        
                    </View>
                </View>

                {/* Table Header */}
                <View style={pdfStyles.table}>
                    <View style={[pdfStyles.tableRow, { backgroundColor: '#d0d0d0' }]} fixed>
                        <View style={[pdfStyles.tableColHeader, pdfStyles.colProductCode]}>
                            <Text style={pdfStyles.tableCellHeader}>Code</Text>
                        </View>
                        <View style={[pdfStyles.tableColHeader, pdfStyles.colName]}>
                            <Text style={pdfStyles.tableCellHeader}>Name</Text>
                        </View>
                        <View style={[pdfStyles.tableColHeader, pdfStyles.colSize]}>
                            <Text style={pdfStyles.tableCellHeader}>Size</Text>
                        </View>
                        <View style={[pdfStyles.tableColHeader, pdfStyles.colUOM]}>
                            <Text style={pdfStyles.tableCellHeader}>UOM</Text>
                        </View>
                        <View style={[pdfStyles.tableColHeader, pdfStyles.colQty]}>
                            <Text style={pdfStyles.tableCellHeader}>Qty</Text>
                        </View>
                        <View style={[pdfStyles.tableColHeader, pdfStyles.colValue]}>
                            <Text style={pdfStyles.tableCellHeader}>Value</Text>
                        </View>
                    </View>

                    {/* Table Rows */}
                    {data.map((item, index) => (
                        <View style={pdfStyles.tableRow} key={item.itemSku + index} wrap={false}>
                            <View style={[pdfStyles.tableCol, pdfStyles.colProductCode]}>
                                <Text style={pdfStyles.tableCell}>{item.itemSku}</Text>
                            </View>
                            <View style={[pdfStyles.tableCol, pdfStyles.colName]}>
                                <Text style={pdfStyles.tableCell}>{item.itemName}</Text>
                            </View>
                            <View style={[pdfStyles.tableCol, pdfStyles.colSize]}>
                                <Text style={pdfStyles.tableCell}>{item.itemSize}</Text>
                            </View>
                            <View style={[pdfStyles.tableCol, pdfStyles.colUOM]}>
                                <Text style={pdfStyles.tableCell}>{item.unitOfMeasure}</Text>
                            </View>
                            <View style={[pdfStyles.tableCol, pdfStyles.colQty]}>
                                <Text style={pdfStyles.tableCellRight}>{item.availableQty}</Text>
                            </View>
                            <View style={[pdfStyles.tableCol, pdfStyles.colValue]}>
                                <Text style={pdfStyles.tableCellRight}>
                                    {parseFloat(item.itemTotalCostValue || 0).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })}
                                </Text>
                            </View>
                        </View>
                    ))}

                    {/* Summary Row */}
                    <View style={pdfStyles.summaryRow} wrap={false}>
                        <View style={{ width: '55%', padding: 5, justifyContent: 'center', borderWidth: 1, borderColor: '#bfbfbf' }}>
                            <Text style={{ fontSize: 9, textAlign: 'right', fontFamily: 'Helvetica-Bold' }}>Total</Text>
                        </View>
                        <View style={[pdfStyles.tableCol, pdfStyles.colUOM]}>
                            <Text style={pdfStyles.tableCell}></Text>
                        </View>
                        <View style={[pdfStyles.tableCol, pdfStyles.colQty]}>
                            <Text style={pdfStyles.tableCellRight}>{totalQty}</Text>
                        </View>
                        <View style={[pdfStyles.tableCol, pdfStyles.colValue]}>
                            <Text style={pdfStyles.tableCellRight}>
                                {totalValue.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })}
                            </Text>
                        </View>
                    </View>
                </View>

                {/* Footer */}
                <Text
                    style={pdfStyles.footer}
                    render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`}
                    fixed
                />
            </Page>
        </Document>
    );
};
